<div class="container">
    <!-- ========================= SECTION MAIN  ========================= -->


    <section class="padding-bottom" *ngFor="let item of categories">
        <header class="section-heading heading-line">
            <h4 class="title-section text-uppercase">{{item.categoryName}}</h4>
        </header>

        <div class="card card-home-category">
            <div class="row no-gutters">
                <div class="col-md-3">

                    <div class="home-category-banner bg-light-orange" style="margin-left: 21px; margin-top: 10px;">
                        <h5 class="title">{{item.categoryName}}</h5>
                        <p>{{item.description}}
                        </p>
                        <img (click)="openSlideShow()" style="height:80%; width:100%; margin-right: 12px;"
                            src="{{item.categoryImage}}" alt="">
                        <a href="#" class="btn btn-outline-primary rounded-pill"
                            style="margin-top: 10px; margin-bottom: 10px;" routerLink="/products">Shop Now</a>

                        <!-- <img src="images/items/2.jpg" class="img-bg"> -->
                    </div>

                </div> <!-- col.// -->

                <div class="col-md-9">
                    <ul class="row no-gutters bordered-cols">

                        <li class="col-6 col-lg-3 col-md-4" *ngFor="let Items of item.categories1">
                            <a routerLink="/products" class="item">
                                <div class="card-body">
                                    <h6 class="title">{{Items.categoryName}} </h6>
                                    <img (click)="openSlideShow()" style="height:80%; width:100%; margin-right: 12px;"
                                        src="{{Items.categoryImage}}" alt="">
                                    <!-- <img class="img-sm float-right" src="images/items/1.jpg"> -->
                                    <p class="text-muted"><i class="fa fa-map-marker-alt"></i> {{Items.description}}
                                    </p>
                                </div>
                            </a>
                        </li>


                        <!-- <li class="col-6 col-lg-3 col-md-4">
                            <a href="#" class="item">
                                <div class="card-body">
                                    <h6 class="title">Great clothes with trending collection </h6>
                                    <img class="img-sm float-right" src="images/items/2.jpg">
                                    <p class="text-muted"><i class="fa fa-map-marker-alt"></i> Beijing, China
                                    </p>
                                </div>
                            </a>
                        </li>
                        <li class="col-6 col-lg-3 col-md-4">
                            <a href="#" class="item">
                                <div class="card-body">
                                    <h6 class="title">Demo clothes with sample collection </h6>
                                    <img class="img-sm float-right" src="images/items/3.jpg">
                                    <p class="text-muted"><i class="fa fa-map-marker-alt"></i> Tokyo, Japan</p>
                                </div>
                            </a>
                        </li>
                        <li class="col-6 col-lg-3 col-md-4">
                            <a href="#" class="item">
                                <div class="card-body">
                                    <h6 class="title">Home and kitchen electronic stuff collection </h6>
                                    <img class="img-sm float-right" src="images/items/4.jpg">
                                    <p class="text-muted"><i class="fa fa-map-marker-alt"></i> Tashkent, Uzb</p>
                                </div>
                            </a>
                        </li>
                        <li class="col-6 col-lg-3 col-md-4">
                            <a href="#" class="item">
                                <div class="card-body">
                                    <h6 class="title">Home and kitchen electronic stuff collection </h6>
                                    <img class="img-sm float-right" src="images/items/5.jpg">
                                    <p class="text-muted"><i class="fa fa-map-marker-alt"></i> London, Britain
                                    </p>
                                </div>
                            </a>
                        </li>
                        <li class="col-6 col-lg-3 col-md-4">
                            <a href="#" class="item">
                                <div class="card-body">
                                    <h6 class="title">Home and kitchen electronic stuff collection </h6>
                                    <img class="img-sm float-right" src="images/items/6.jpg">
                                    <p class="text-muted"><i class="fa fa-map-marker-alt"></i> Guanjou, China
                                    </p>
                                </div>
                            </a>
                        </li>
                        <li class="col-6 col-lg-3 col-md-4">
                            <a href="#" class="item">
                                <div class="card-body">
                                    <h6 class="title">Well made clothes with trending collection </h6>
                                    <img class="img-sm float-right" src="images/items/7.jpg">
                                    <p class="text-muted"><i class="fa fa-map-marker-alt"></i> Hong Kong, China
                                    </p>

                                </div>
                            </a>
                        </li>
                        <li class="col-6 col-lg-3 col-md-4">
                            <a href="#" class="item">
                                <div class="card-body">
                                    <h6 class="title">Home and kitchen interior stuff collection </h6>
                                    <img class="img-sm float-right" src="images/items/6.jpg">
                                    <p class="text-muted"><i class="fa fa-map-marker-alt"></i> Guanjou, China
                                    </p>
                                </div>
                            </a>
                        </li> -->
                    </ul>
                </div> <!-- col.// -->
            </div> <!-- row.// -->
        </div> <!-- card.// -->
    </section>


</div>